/**
 * Tooltip props helpers. Elements opt in with `data-tooltip` (and optionally
 * `data-tooltip-shortcut`); the single `<TooltipHost>` renders the tooltip. Using data attributes
 * instead of a wrapper component keeps markup flat and works for any element type.
 */
import { COMMANDS, formatShortcut } from './commands.ts';

export interface TooltipProps {
  'data-tooltip': string;
  'data-tooltip-shortcut'?: string;
  'aria-label': string;
}

/** Tooltip with an optional raw shortcut, e.g. `tip('Zoom in', '=')`. */
export function tip(label: string, shortcut?: string): TooltipProps {
  return {
    'data-tooltip': label,
    'aria-label': label,
    ...(shortcut ? { 'data-tooltip-shortcut': formatShortcut(shortcut) } : {}),
  };
}

/** Tooltip for a registered command: label and shortcut come from the command registry. */
export function commandTip(commandId: string, label?: string): TooltipProps {
  const cmd = COMMANDS.find((c) => c.id === commandId);
  if (!cmd) throw new Error(`Unknown command ${commandId}`);
  const shortcut = Array.isArray(cmd.shortcut) ? cmd.shortcut[0] : cmd.shortcut;
  return tip(label ?? cmd.label, shortcut);
}
